namespace GeniuzPOS.SalePromoCamp {
    export interface PsPromoShopRow {
        Id?: number;
        PromoId?: string;
        ShopId?: string;
    }

    export namespace PsPromoShopRow {
        export const idProperty = 'Id';
        export const nameProperty = 'PromoId';
        export const localTextPrefix = 'SalePromoCamp.PsPromoShop';
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            PromoId = "PromoId",
            ShopId = "ShopId"
        }
    }
}
